import Box from "@mui/material/Box";
import {FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {useState} from "react";

export default function SwapTokenCard() {

    const [inputToken, setInputToken] = useState("APTOS")

    const handleChangeInputToken = (input: any) => {
        setInputToken(input.target.value)
    }

    return <Box sx={{flexGrow: 1}}>
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <InputLabel id="demo-simple-select-helper-label">Token</InputLabel>
                    <Select
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={inputToken}
                        label="Age"
                        onChange={handleChangeInputToken}
                    >
                        <MenuItem value="APTOS">APTOS</MenuItem>
                        <MenuItem value="USDC">USDC</MenuItem>
                        <MenuItem value="USDT">USDT</MenuItem>
                    </Select>
                    <FormHelperText>$: --</FormHelperText>
                </FormControl>
            </Grid>
            <Grid item xs={6}>
                <FormControl sx={{m: 1, minWidth: 120}}>
                    <TextField id="standard-basic" label="Amount" variant="standard"/>
                    <FormHelperText>Balance: --</FormHelperText>
                </FormControl>
            </Grid>
        </Grid>
    </Box>
}